import { Box, Divider, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FC } from "react";
import { useShallow } from "zustand/shallow";
import { useCollectionDialogStore } from "./stores/CollectionDialogStore";

export const Header: FC = () => {
  const { setIsVisible, editingCollectionId } = useCollectionDialogStore(
    useShallow((state) => ({
      setIsVisible: state.setIsVisible,
      editingCollectionId: state.editingCollectionId,
    }))
  );

  const handleClose = () => {
    setIsVisible(false);
  };

  const title = editingCollectionId ? "Edit Collection" : "Add Collection";

  return (
    <Box>
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        padding="24px 20px"
      >
        <Typography data-testid="collection-dialog-title" variant="h2">
          {title}
        </Typography>
        <IconButton
          data-testid="collection-dialog-close-btn"
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </Stack>
      <Divider />
    </Box>
  );
};
